import React from 'react'

import clsx from 'clsx'
import { Gift } from 'lucide-react'

import { GiftCard } from '../type'

interface GiftCardTileProps {
  card: GiftCard
}

export const GiftCardTile: React.FC<GiftCardTileProps> = ({ card }) => {
  const meta = [card.note, `from ${card.initialBalanceFormatted}`].filter(Boolean).join(' · ')

  return (
    <article
      className={clsx('user-profile-gift-card', card.designUrl && 'user-profile-gift-card_has-image')}
      style={
        card.designUrl
          ? {
              backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.05) 45%), url("${card.designUrl}")`,
            }
          : undefined
      }
    >
      <div className="user-profile-gift-card__top">
        <Gift aria-hidden size={16} strokeWidth={1.75} />
        Gift card
      </div>
      <p className="user-profile-gift-card__balance">{card.balanceFormatted}</p>
      <div className="user-profile-gift-card__bottom">
        <span className="user-profile-gift-card__code">•••• {card.last4}</span>
        <span className="user-profile-gift-card__meta">{meta}</span>
      </div>
    </article>
  )
}
